import { render } from "./Massblocker.vue?vue&type=template&id=05d60680"
import script from "./Massblocker.vue?vue&type=script&lang=js"
export * from "./Massblocker.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__